import { action, computed, observable } from 'mobx'

import { processApiError } from 'shared/api/utils'

import {
  adaptGetPaymentSettingsResponse,
  adaptPutPaymentSettingsErrors,
  adaptPutPaymentSettingsRequest,
} from 'supplier/adapters/settings'
import { getPaymentSettings, putPaymentSettings } from 'supplier/api/settings'
import { ApiStatusStore } from 'supplier/stores'

class PaypalSettingsStore {
  /** @type {import('../root').RootStore} */
  root

  apiStatus = new ApiStatusStore()

  @observable paypalEmail

  /**
   * @param {import('../root').RootStore} root
   */
  constructor (root) {
    this.root = root
  }

  @action.bound
  update (data) {
    Object.assign(this, data)
  }

  @computed get defaultValues () {
    return {
      paypalEmail: this.paypalEmail || '',
    }
  }

  @action.bound
  async fetch () {
    this.apiStatus.startLoad()
    try {
      const paymentSettingsResponse = await getPaymentSettings()
      const data = adaptGetPaymentSettingsResponse(paymentSettingsResponse.data)
      this.update(data)
      this.apiStatus.finishLoad()
      return data
    } catch (error) {
      this.apiStatus.failLoad('We could not fetch the payment settings. Please try again in a minute.')
      throw error
    }
  }

  @action.bound
  submit (data) {
    this.apiStatus.startSave()
    const payload = adaptPutPaymentSettingsRequest(data)
    return putPaymentSettings(payload)
      .then(response => {
        const next = adaptGetPaymentSettingsResponse(response.data)
        this.update(next)
        this.apiStatus.finishSave()
        return next
      })
      .catch(error => {
        const errors = processApiError(error, adaptPutPaymentSettingsErrors)
        this.apiStatus.setRemoteErrors(errors)
        this.apiStatus.failSave('We could not save the payment settings')
        throw error
      })
  }

  @action.bound
  reset () {
    this.apiStatus.reset()
  }
}

export default PaypalSettingsStore
